export interface ITag {
  color: string;
  outline?: boolean;
  light?: boolean;
  filled?: boolean;
}

export enum TAGS {
  HR = 'hr',
  RECRUITING = 'recruiting & onboarding',
  COMPANY = 'company',
  PRODUCT = 'product',
  EMPLOYEE = 'employee experience',
  TRAINING = 'training',
}

export const getTag = (tag: string): ITag => {
  switch (tag.toLowerCase()) {
    case TAGS.HR:
      return {
        color: 'inevitable',
        light: true,
      };
    case TAGS.RECRUITING:
      return {
        color: 'caribbean',
        light: true,
      };
    case TAGS.COMPANY:
      return {
        color: 'gray',
        light: true,
      };
    case TAGS.PRODUCT:
      return {
        color: 'eastern',
        light: true,
      };
    case TAGS.EMPLOYEE:
      return {
        color: 'virginia',
        light: true,
      };
    case TAGS.TRAINING:
      return {
        color: 'rose',
      };
    default:
      return {
        color: 'rose',
        light: true,
      };
  }
};
